function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/* global React, window, PRODUCTS */
/* global Button, Pill, Eyebrow, Icon */
// ============================================================================
// Cart Drawer — right side overlay. Clean editorial.
// ============================================================================
var _React = React,
  useStateCart = _React.useState,
  useEffectCart = _React.useEffect,
  useMemoCart = _React.useMemo;
function CartDrawer(_ref) {
  var open = _ref.open,
    items = _ref.items,
    onClose = _ref.onClose,
    _onRemove = _ref.onRemove,
    onUpdate = _ref.onUpdate,
    onCheckout = _ref.onCheckout,
    onCard = _ref.onCard;
  useEffectCart(function () {
    var k = function k(e) {
      if (e.key === "Escape" && open) onClose();
    };
    document.addEventListener("keydown", k);
    return function () {
      return document.removeEventListener("keydown", k);
    };
  }, [open, onClose]);
  var subtotal = useMemoCart(function () {
    return items.reduce(function (s, it) {
      return s + it.price * (it.qty || 1);
    }, 0);
  }, [items]);
  var shipping = subtotal === 0 ? 0 : 8;
  var donated = subtotal * 0.10;
  var inCart = new Set(items.map(function (it) {
    return it.id;
  }));
  var upsell = PRODUCTS.filter(function (p) {
    return !inCart.has(p.id);
  }).slice(0, 2);
  if (!open) return null;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    onClick: onClose,
    style: {
      position: "fixed",
      inset: 0,
      zIndex: 90,
      background: "rgba(20,20,20,0.45)",
      backdropFilter: "blur(4px)",
      WebkitBackdropFilter: "blur(4px)",
      animation: "fade-in 200ms var(--ease)"
    }
  }), /*#__PURE__*/React.createElement("aside", {
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      zIndex: 91,
      width: "min(100vw, 480px)",
      background: "var(--bone)",
      borderLeft: "1px solid var(--line)",
      display: "flex",
      flexDirection: "column",
      animation: "slide-in 280ms var(--ease-out)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "20px 28px",
      borderBottom: "1px solid var(--line)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      alignItems: "baseline",
      gap: 12
    }
  }, /*#__PURE__*/React.createElement("h2", {
    style: {
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: 32,
      margin: 0
    }
  }, "Cart"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-mono)",
      fontSize: 12,
      color: "var(--muted)"
    }
  }, "\xB7 ", items.length, " ", items.length === 1 ? "piece" : "pieces")), /*#__PURE__*/React.createElement("button", {
    onClick: onClose,
    "aria-label": "Close",
    style: {
      background: "transparent",
      border: "1px solid var(--ink)",
      padding: 8,
      cursor: "pointer"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "close",
    size: 16
  }))), items.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "14px 28px",
      borderBottom: "1px solid var(--line)",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      fontSize: 12
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      display: "inline-flex",
      alignItems: "center",
      gap: 8
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      width: 6,
      height: 6,
      borderRadius: 3,
      background: "var(--rust)"
    }
  }), /*#__PURE__*/React.createElement("span", null, "This order funds ", /*#__PURE__*/React.createElement("strong", {
    style: {
      color: "var(--ink)"
    }
  }, "$", donated.toFixed(2)), " to grassroots orgs")), /*#__PURE__*/React.createElement("a", {
    href: "/#issues",
    onClick: function onClick(e) {
      e.preventDefault();
      onClose();
      setTimeout(function () {
        var _document$getElementB;
        return (_document$getElementB = document.getElementById("issues")) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.scrollIntoView({
          behavior: "smooth"
        });
      }, 100);
    },
    style: {
      fontFamily: "var(--font-sans)",
      fontSize: 11,
      letterSpacing: "0.06em",
      color: "var(--muted)",
      borderBottom: "1px solid var(--line-2)",
      textTransform: "uppercase"
    }
  }, "How?")), /*#__PURE__*/React.createElement("div", {
    style: {
      flex: 1,
      overflowY: "auto"
    }
  }, items.length === 0 ? /*#__PURE__*/React.createElement(EmptyCart, {
    onClose: onClose
  }) : items.map(function (it, i) {
    return /*#__PURE__*/React.createElement(CartRow, {
      key: i,
      it: it,
      onRemove: function onRemove() {
        return _onRemove(i);
      },
      onQty: function onQty(q) {
        return onUpdate(i, {
          qty: q
        });
      }
    });
  }), items.length > 0 && upsell.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "32px 28px 16px"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 11,
      letterSpacing: "0.16em",
      textTransform: "uppercase",
      color: "var(--muted)",
      marginBottom: 16
    }
  }, "You might also want"), upsell.map(function (p) {
    return /*#__PURE__*/React.createElement("button", {
      key: p.id,
      onClick: function onClick() {
        return onCard === null || onCard === void 0 ? void 0 : onCard(p);
      },
      style: {
        display: "grid",
        gridTemplateColumns: "60px 1fr auto",
        gap: 14,
        alignItems: "center",
        background: "transparent",
        border: "none",
        padding: "10px 0",
        cursor: "pointer",
        width: "100%",
        textAlign: "left",
        borderBottom: "1px solid var(--line)"
      }
    }, /*#__PURE__*/React.createElement("img", {
      src: p.img,
      alt: "",
      style: {
        width: 60,
        height: 60,
        objectFit: "cover"
      }
    }), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
      style: {
        fontFamily: "var(--font-serif)",
        fontSize: 18,
        lineHeight: 1.15,
        color: "var(--ink)"
      }
    }, p.name), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 11,
        color: "var(--muted)",
        letterSpacing: "0.08em",
        textTransform: "uppercase"
      }
    }, p.type)), /*#__PURE__*/React.createElement("div", {
      style: {
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        gap: 4
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        fontFamily: "var(--font-serif)",
        fontSize: 18,
        color: "var(--ink)"
      }
    }, "$", p.price.toFixed(0)), /*#__PURE__*/React.createElement("span", {
      style: {
        fontSize: 10,
        letterSpacing: "0.06em",
        color: "var(--rust)",
        textTransform: "uppercase"
      }
    }, "+ Add")));
  }))), items.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "16px 28px",
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement(CouponRow, null)), items.length > 0 && /*#__PURE__*/React.createElement("div", {
    style: {
      padding: 28,
      borderTop: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 6,
      marginBottom: 16
    }
  }, /*#__PURE__*/React.createElement(CartRow2, {
    k: "Subtotal",
    v: "$".concat(subtotal.toFixed(2))
  }), /*#__PURE__*/React.createElement(CartRow2, {
    k: "Shipping",
    v: shipping === 0 ? "—" : "$".concat(shipping.toFixed(2))
  }), /*#__PURE__*/React.createElement(CartRow2, {
    k: "10% to grassroots orgs",
    v: "$".concat(donated.toFixed(2)),
    accent: true
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "baseline",
      padding: "16px 0",
      borderTop: "1px solid var(--ink)",
      borderBottom: "1px solid var(--ink)",
      marginBottom: 18
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-serif)",
      fontStyle: "italic",
      fontSize: 22
    }
  }, "Total"), /*#__PURE__*/React.createElement("span", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 36,
      lineHeight: 1
    }
  }, "$", (subtotal + shipping).toFixed(2))), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    size: "lg",
    onClick: onCheckout,
    style: {
      width: "100%",
      justifyContent: "center"
    }
  }, "Checkout ", /*#__PURE__*/React.createElement(Icon, {
    name: "arrowR",
    size: 14
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      textAlign: "center",
      fontFamily: "var(--font-sans)",
      fontSize: 11,
      letterSpacing: "0.08em",
      color: "var(--muted)"
    }
  }, "Shop Pay \xB7 Apple Pay \xB7 PayPal \xB7 Card \u2014 shipping & taxes calculated at checkout"))));
}
function CartRow(_ref2) {
  var it = _ref2.it,
    onRemove = _ref2.onRemove,
    onQty = _ref2.onQty;
  var qty = it.qty || 1;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "grid",
      gridTemplateColumns: "84px 1fr",
      gap: 16,
      padding: "20px 28px",
      borderBottom: "1px solid var(--line)"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      aspectRatio: "1/1.1",
      background: "var(--bone-2)",
      overflow: "hidden"
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: it.img,
    alt: it.name,
    style: {
      width: "100%",
      height: "100%",
      objectFit: "cover"
    }
  })), /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      flexDirection: "column",
      gap: 6
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      gap: 10,
      alignItems: "flex-start"
    }
  }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 11,
      letterSpacing: "0.08em",
      color: "var(--muted)",
      textTransform: "uppercase"
    }
  }, it.cause), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 18,
      lineHeight: 1.15,
      color: "var(--ink)",
      marginTop: 4
    }
  }, it.name)), /*#__PURE__*/React.createElement("div", {
    style: {
      fontFamily: "var(--font-serif)",
      fontSize: 18,
      whiteSpace: "nowrap"
    }
  }, "$", (it.price * qty).toFixed(2))), /*#__PURE__*/React.createElement("div", {
    style: {
      fontSize: 12,
      color: "var(--muted)"
    }
  }, "Size ", it.size || "M", " \xB7 ", it.color || "Black"), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: "auto",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      paddingTop: 4
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "inline-flex",
      border: "1px solid var(--line-2)"
    }
  }, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onQty(Math.max(1, qty - 1));
    },
    style: cartQtyBtn
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "minus",
    size: 11
  })), /*#__PURE__*/React.createElement("span", {
    style: {
      minWidth: 28,
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "center",
      fontSize: 13
    }
  }, qty), /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return onQty(qty + 1);
    },
    style: cartQtyBtn
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "plus",
    size: 11
  }))), /*#__PURE__*/React.createElement("button", {
    onClick: onRemove,
    style: {
      background: "transparent",
      border: "none",
      padding: 0,
      fontSize: 11,
      color: "var(--muted)",
      cursor: "pointer",
      letterSpacing: "0.06em",
      textTransform: "uppercase"
    },
    onMouseEnter: function onMouseEnter(e) {
      return e.currentTarget.style.color = "var(--rust)";
    },
    onMouseLeave: function onMouseLeave(e) {
      return e.currentTarget.style.color = "var(--muted)";
    }
  }, "Remove"))));
}
var cartQtyBtn = {
  width: 28,
  height: 28,
  background: "transparent",
  border: "none",
  cursor: "pointer",
  color: "var(--ink)",
  display: "inline-flex",
  alignItems: "center",
  justifyContent: "center"
};
function CartRow2(_ref3) {
  var k = _ref3.k,
    v = _ref3.v,
    accent = _ref3.accent;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex",
      justifyContent: "space-between",
      fontSize: 13
    }
  }, /*#__PURE__*/React.createElement("span", {
    style: {
      color: "var(--muted)"
    }
  }, k), /*#__PURE__*/React.createElement("span", {
    style: {
      color: accent ? "var(--rust)" : "var(--ink)",
      fontFamily: "var(--font-mono)"
    }
  }, v));
}
function CouponRow() {
  var _useStateCart = useStateCart(""),
    _useStateCart2 = _slicedToArray(_useStateCart, 2),
    code = _useStateCart2[0],
    setCode = _useStateCart2[1];
  var _useStateCart3 = useStateCart(false),
    _useStateCart4 = _slicedToArray(_useStateCart3, 2),
    open = _useStateCart4[0],
    setOpen = _useStateCart4[1];
  var _useStateCart5 = useStateCart(null),
    _useStateCart6 = _slicedToArray(_useStateCart5, 2),
    applied = _useStateCart6[0],
    setApplied = _useStateCart6[1];
  var VALID = {
    DECEMBER: "20% off · 14 collections",
    LOTITA: "10% off · no limits",
    PROTEST26: "Buy 2, save 15%"
  };
  var apply = function apply() {
    var k = code.trim().toUpperCase();
    if (VALID[k]) setApplied(k);else {
      setApplied(null);
      alert("Coupon not valid");
    }
  };
  return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("button", {
    onClick: function onClick() {
      return setOpen(!open);
    },
    style: {
      background: "transparent",
      border: "none",
      padding: 0,
      width: "100%",
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontSize: 12,
      letterSpacing: "0.05em",
      color: "var(--ink)"
    }
  }, /*#__PURE__*/React.createElement("span", null, applied ? "\u2713 Code ".concat(applied, " applied") : "Add a discount code"), /*#__PURE__*/React.createElement(Icon, {
    name: "arrowDown",
    size: 12,
    style: {
      transform: open ? "rotate(180deg)" : "rotate(0)",
      transition: "transform 200ms"
    }
  })), open && /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 14,
      animation: "fade-in 160ms"
    }
  }, /*#__PURE__*/React.createElement("div", {
    style: {
      display: "flex"
    }
  }, /*#__PURE__*/React.createElement("input", {
    value: code,
    onChange: function onChange(e) {
      return setCode(e.target.value.toUpperCase());
    },
    placeholder: "Enter code",
    style: {
      flex: 1,
      border: "1px solid var(--line-2)",
      borderRight: "none",
      background: "transparent",
      color: "var(--ink)",
      padding: "8px 12px",
      outline: "none",
      fontFamily: "var(--font-mono)",
      fontSize: 12
    }
  }), /*#__PURE__*/React.createElement("button", {
    onClick: apply,
    style: {
      background: "var(--ink)",
      color: "var(--bone)",
      border: "1px solid var(--ink)",
      padding: "0 18px",
      cursor: "pointer",
      fontFamily: "var(--font-sans)",
      fontWeight: 500,
      fontSize: 12
    }
  }, "Apply")), /*#__PURE__*/React.createElement("div", {
    style: {
      marginTop: 10,
      display: "flex",
      flexDirection: "column",
      gap: 4
    }
  }, Object.entries(VALID).map(function (_ref4) {
    var _ref5 = _slicedToArray(_ref4, 2),
      k = _ref5[0],
      d = _ref5[1];
    return /*#__PURE__*/React.createElement("button", {
      key: k,
      onClick: function onClick() {
        return setCode(k);
      },
      style: {
        background: "transparent",
        border: "none",
        padding: 0,
        cursor: "pointer",
        fontFamily: "var(--font-mono)",
        fontSize: 11,
        color: "var(--muted)",
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement("span", {
      style: {
        color: "var(--ink)"
      }
    }, k), " \u2014 ", d);
  }))));
}
function EmptyCart(_ref6) {
  var onClose = _ref6.onClose;
  return /*#__PURE__*/React.createElement("div", {
    style: {
      padding: "64px 28px",
      textAlign: "center"
    }
  }, /*#__PURE__*/React.createElement(Icon, {
    name: "bag",
    size: 48,
    color: "var(--line-2)"
  }), /*#__PURE__*/React.createElement("h3", {
    style: {
      fontFamily: "var(--font-serif)",
      fontWeight: 400,
      fontSize: 36,
      lineHeight: 1.1,
      margin: "16px 0 8px",
      color: "var(--ink)"
    }
  }, "Your cart is ", /*#__PURE__*/React.createElement("em", {
    style: {
      fontStyle: "italic"
    }
  }, "empty.")), /*#__PURE__*/React.createElement("p", {
    style: {
      color: "var(--muted)",
      fontSize: 14,
      maxWidth: 280,
      margin: "0 auto 24px"
    }
  }, "Resistance starts with a single stitch."), /*#__PURE__*/React.createElement(Button, {
    variant: "primary",
    onClick: onClose
  }, "Shop the drop"));
}
Object.assign(window, {
  CartDrawer: CartDrawer
});
